// extracted by mini-css-extract-plugin
export default {"terminateWorkflowDialog":"terminateWorkflowDialog-fRZvS","contents":"contents-e77r0"};